import React from 'react';
import '../../storeLocator.css';
import { capitlizeFirstLetter } from 'globalUtils';
import { Label } from '@nooz-optics/nooz-components-lib';

export const Popup = ({
  data: { name, address1, postcode, city, state, country },
}) => (
  <div alignItems='mapboxgl-popup-close-button mapboxgl-popup flex-start'>
    <Label
      weight='bold'
      size='base'
      color={{ classname: 'black' }}
      text={name}
    />
    <Label text={address1} />
    <Label text={postcode} />
    <Label text={capitlizeFirstLetter(city)} />
    <Label text={capitlizeFirstLetter(state)} />
    <Label text={capitlizeFirstLetter(country)} />
  </div>
);
